module.exports = __webpack_public_path__ + "img/MilitaryTechBackgroundC02_ua.a5d40e4c.webp";